/* esm.sh - esbuild bundle(bail@2.0.2) deno production */
function t(i){if(i)throw i}export{t as bail};
//# sourceMappingURL=bail.js.map